/*
 * @Author: wangshengqiang
 * @Date: 2021-05-12 17:27:15
 * @LastEditTime: 2021-05-12 17:27:30
 * @LastEditors: wangshengqiang
 * @Description: d
 */
import React from 'react';
import cn from 'classnames';
import './index.less';
export default function Block(props) {
  const {
    noGap,
    _label,
    remark,
    showLabel,
    title,
    className,
    titleClass,
    children
  } = props;
  const cls = cn('cc-block', {
    'cc-block--nogap': noGap
  }, className);

  const _title = showLabel === false ? '' : title || _label;

  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, children);
}